import React, { useContext, useEffect } from "react";
import mapboxgl, { LngLatBounds } from "mapbox-gl";
import { ControlPosition, useIsMounted, useMapbox } from "Hooks";
import { useApiClient } from "Services/API/useApiClient";
import { GeocodeRequestModel, GeocoderClient } from "Services/API/API";
import { ActivityContext } from "../contexts";

interface MapProps {
   className?: string;
   mapRef: React.MutableRefObject<mapboxgl.Map | undefined>;
   setLoaded?: (state: boolean) => void;
   fullscreenContainer?: HTMLElement | null
}

const ZOOM_CONTROL_POSITION: ControlPosition = "top-left";
const FULL_SCREEN_CONTROL_POSITION: ControlPosition = "top-left";

const Map: React.FC<MapProps> = ({ className, mapRef, setLoaded, fullscreenContainer }) => {
   const { mapContainerRef, getMapbox } = useMapbox();

   const { homebaseCountry } = useContext(ActivityContext);

   useEffect(() => {
      const map = getMapbox();
      mapRef.current = map;

      map.on("load", () => {
         console.log("Loaded resize");
         map.resize();
         setLoaded?.(true);
      });
      map.on("render", () => {
         // console.log("Render resize");
         // map.resize();
      })

      map.addControl(
         new mapboxgl.FullscreenControl({
            container: fullscreenContainer
         }),
         FULL_SCREEN_CONTROL_POSITION
      );
      map.addControl(new mapboxgl.NavigationControl({
         showCompass: false
      }), ZOOM_CONTROL_POSITION);
      map.dragRotate.disable();
      map.touchZoomRotate.disableRotation();

      return () => {
         map.remove();
         setLoaded?.(false);
      };
   }, []);


   const geocoderClient = useApiClient(GeocoderClient);

   useEffect(() => {
      if (!homebaseCountry || homebaseCountry.code === "US") {
         fitUS();
      }
      else {
         const abortController = new AbortController();

         geocoderClient.geocode(new GeocodeRequestModel({
            address: homebaseCountry.name ?? homebaseCountry.code
         }), abortController.signal)
            .then(data => {
               const viewport = data[0]?.viewport;
               if (viewport) {
                  const map = getMapbox();
                  console.log("fitCountry");
                  map.fitBounds(new LngLatBounds(
                     { lat: viewport.southWest.latitude, lng: viewport.southWest.longitude },
                     { lat: viewport.northEast.latitude, lng: viewport.northEast.longitude }
                  ),
                     {
                        animate: false,
                        padding: {
                           top: 0,
                           left: 0,
                           bottom: 170,
                           right: 434
                        }
                     }
                  );
               }
               else {
                  fitUS();
               }
            });

         return () => abortController.abort();
      }

      function fitUS() {
         const map = getMapbox();
         console.log("fitUS");

         map.fitBounds(
            [
               [-100, 34], // [lng, lat] - southwestern corner of the bounds
               [-92, 40], // [lng, lat] - northeastern corner of the bounds
            ],
            {
               animate: false,
               padding: {
                  top: 0,
                  left: 0,
                  bottom: 170,
                  right: 434
               }
            }
         );
      }
   }, [homebaseCountry?.code ?? "US"]);

   return (
      <div ref={mapContainerRef} className={className}>
      </div>
   );
};


export default Map;
